/**
 * AudioInputContext.tsx
 *
 * Provides audio-input device state (stream, devices, selection) to the
 * entire JamCam component tree.  Placed at the app level so all modules
 * share a single mic stream and device selector.
 */

import { createContext, useContext, ReactNode } from 'react';
import { useAudioInput, UseAudioInputReturn } from '../hooks/useAudioInput';

const AudioInputContext = createContext<UseAudioInputReturn | null>(null);

export function AudioInputProvider({
  children,
  enabled = true,
}: {
  children: ReactNode;
  enabled?: boolean;
}) {
  const audioInput = useAudioInput(enabled);
  return (
    <AudioInputContext.Provider value={audioInput}>
      {children}
    </AudioInputContext.Provider>
  );
}

export function useAudioInputContext(): UseAudioInputReturn {
  const ctx = useContext(AudioInputContext);
  if (!ctx) {
    throw new Error(
      'useAudioInputContext must be used within an <AudioInputProvider>'
    );
  }
  return ctx;
}
